package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textDecoration
import org.lennycodes.hldi.constants.HLDITheme

val LogoStyle = CssStyle {
    base {
        Modifier
            . fontSize(24.px)
            .fontWeight(700)
            .color(HLDITheme.Colors.primary)
            .textDecorationLine(TextDecorationLine.None)
            .fontFamily("Playfair Display", "serif")
    }
}
